import { useState } from 'preact/hooks'
import { AthosProduct } from 'libs/athos/fetchers/product'
import { useAthosFetcher } from 'libs/athos/fetchers/provider'
import { normaliseResults } from 'libs/athos/helpers/normalisers'

export function useSwatches(initialResult) {
  const [currentResult, setCurrentResult] = useState(initialResult)

  const { isLoading, refine } = useAthosFetcher(new AthosProduct(), {
    runOnMount: false,
    onFetch: handleFetch
  })

  async function handleFetch(data) {
    if (!isLoading && data.results.length > 0) {
      const result = await normaliseResults(data.results)
      setCurrentResult(result[0])
      return result
    }
    return {}
  }

  const updateSwatch = (handle) => {
    refine('handle', handle)
  }

  return { currentResult, isLoading, updateSwatch }
}
